import React from "react";
import { MapPin, Phone, Mail, Clock, Building2 } from "lucide-react";

const cards = [
  { icon: Building2, title: "Firmă", lines: ["One Tool SRL", "Magazin online Mimaso"] },
  { icon: MapPin, title: "Adresă", lines: ["Centru Logistic", "Chiajna, Ilfov, România"] },
  { icon: Phone, title: "Telefon", lines: ["+40 734 154 845"], href: "tel:+40734154845" },
  { icon: Mail, title: "Email", lines: ["comenzi@mimasodirect.ro"], href: "mailto:comenzi@mimasodirect.ro" },
  { icon: Clock, title: "Program", lines: ["Luni - Vineri", "09:00 - 18:00"] },
];

export default function Contact() {
  return (
    <div className="bubble-bg" data-testid="contact-page">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-12">
        <header className="max-w-2xl">
          <span className="label-caps text-sky-600">Contact</span>
          <h1 className="mt-2 font-display text-4xl font-black tracking-tight text-slate-900 lg:text-5xl">Suntem aici pentru tine</h1>
          <p className="mt-4 text-slate-600">
            Ai întrebări despre produse, comenzi sau oferte? Contactează-ne telefonic sau pe email,
            iar echipa Mimaso îți răspunde cu drag.
          </p>
        </header>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((c) => {
            const content = (
              <div className="h-full rounded-2xl border border-slate-100 bg-white p-7 shadow-[0_8px_32px_rgba(2,132,199,0.05)] transition-all hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(2,132,199,0.12)]">
                <div className="grid h-12 w-12 place-items-center rounded-xl bg-sky-100 text-sky-600">
                  <c.icon className="h-5 w-5" />
                </div>
                <h3 className="mt-4 font-display text-lg font-bold text-slate-900">{c.title}</h3>
                {c.lines.map((l) => (
                  <p key={l} className="text-slate-600">{l}</p>
                ))}
              </div>
            );
            return c.href ? (
              <a key={c.title} href={c.href} data-testid={`contact-${c.title.toLowerCase()}`}>{content}</a>
            ) : (
              <div key={c.title} data-testid={`contact-${c.title.toLowerCase()}`}>{content}</div>
            );
          })}
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl border border-slate-100">
          <iframe
            title="Hartă Mimaso"
            src="https://www.google.com/maps?q=Chiajna,+Ilfov,+Romania&output=embed"
            className="h-80 w-full border-0"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
